<template>
  <div class="equipModel">
    <div class="left-container">
      <div class="head-portrait">
        <div class="imgs-container">
          <img :src="particular.photoLink" />
        </div>
      </div>
      <div class="text-conten">
        <div class="yq_name">
          <span>所在仪器柜：</span>
          <span>建科院1号智能柜</span>
        </div>
        <div class="slogan">
          <span>位置：</span>
          {{ particular.boxIndex }}
        </div>
        <template v-if="particular.states == 0">
          <div class="state state1">
            <i class="yuandian"></i>
            <span>正常</span>
          </div>
        </template>
        <template v-if="particular.states == 1">
          <div class="state state3">
            <i class="yuandian"></i>
            <span>降级</span>
          </div>
        </template>
        <template v-if="particular.states == 2">
          <div class="state state2">
            <i class="yuandian"></i>
            <span>停用</span>
          </div>
        </template>
        <template v-if="particular.states == 3">
          <div class="state state2">
            <i class="yuandian"></i>
            <span>需维修</span>
          </div>
        </template>
        <template v-if="particular.states == 4">
          <div class="state state3">
            <i class="yuandian"></i>
            <span>需检定</span>
          </div>
        </template>
        <template v-if="particular.states == 5">
          <div class="state state3">
            <i class="yuandian"></i>
            <span>需保养</span>
          </div>
        </template>
        <template v-if="particular.states ==6 ">
          <div class="state state3">
            <i class="yuandian"></i>
            <span>报废</span>
          </div>
        </template>
      </div>
      <div class="qcode">
        <div class="imgs-container">
          <img :src="particular.qrcodeUrl" />
        </div>
      </div>
    </div>
    <div class="right-container">
      <div class="btn-list">
        <div v-if="particular.states != 2" class="my-buttom select-buttom" @click="outage">停用</div>
        <div class="my-buttom" @click="delelItem()">删除</div>
      </div>
      <div class="container-title">
        <span class="instryment-name">{{ particular.instrumentName }}</span
        ><span>设备编号：</span> {{ particular.serialNumber }}
      </div>
      <div class="Instrument-list">
        <div class="vessel bar">
          <template v-for="(item, index) in particular.child">
            <div
              :class="['list-item', selectID == item.id ? 'selec-item' : '']"
              :key="index"
              @click="SelecIten(item)"
            >
              <span class="tag-item">{{ item.instrumentName }}</span>
              <span
                class="tag-icon iconfont icon-shanchu"
                @click.stop="handleClose(item)"
              ></span>
            </div>
          </template>
        </div>

        <div class="add-buttom" @click="addYq">
          <span class="iconfont icon-tianjia"></span> <span>添加仪器</span>
        </div>
      </div>
      <div class="Instrument-detail">
        <div class="detail">
          <template v-if="selectItem">
            <div class="card-item">
              <div class="card-item-top">
                <div class="equip-imag">
                  <template v-if="selectItem.status == 0">
                    <div class="img-icon1 imgs-icon">
                      <img :src="selectItem.photoUrl" alt />
                    </div>
                  
                  </template>
                  <template v-if="selectItem.status == 1">
                    <div class="img-icon2 imgs-icon">
                      <img :src="selectItem.photoUrl" alt />
                    </div>
                  
                  </template>
                  <template v-if="selectItem.status == 2">
                    <div class="img-icon2 imgs-icon">
                      <img :src="selectItem.photoUrl" alt />
                    </div>
                   
                  </template>
                  <template v-if="selectItem.status == 3">
                    <div class="img-icon2 imgs-icon">
                      <img :src="selectItem.photoUrl" alt />
                    </div>
                   
                  </template>
                  <template v-if="selectItem.status == 4">
                    <div class="img-icon2 imgs-icon">
                      <img :src="selectItem.photoUrl" alt />
                    </div>
                  
                  </template>
                  <template v-if="selectItem.status == 5">
                    <div class="img-icon2 imgs-icon">
                      <img :src="selectItem.photoUrl" alt />
                    </div>
                  
                  </template>
                </div>
                <div class="equip-detail">
                  <div class="items">
                    <span>{{ selectItem.instrumentName }}</span>
                  </div>
                  <div class="items tow-columns">
                    <div class="left_item">
                      <span>编号：</span>
                      <span>{{ selectItem.serialNumber }}</span>
                    </div>
                    <div class="rigth_item">
                      <span>型号：</span>
                      <span>{{ selectItem.pattern }}</span>
                    </div>
                  </div>
                 
                </div>
              </div>
              <div class="card-item-bottom">
                <div class="row-item">
                  <span>厂家：</span>
                  <span>{{ selectItem.factoryName }}</span>
                </div>
                <div class="row-item">
                  <span>启用时间：</span>
                  <span>{{ selectItem.startUpTime }}</span>
                </div>
                <div class="row-item">
                  <div class="left_item">
                    <span>精度：</span>
                    <span>{{ selectItem.precision }}</span>
                  </div>
                  <div class="rigth_item">
                    <span>检定有效期：</span>
                    <span>{{ selectItem.validityEffectiveTime }}</span>
                  </div>
                </div>
                <div class="row-item">
                  <div class="left_item">
                    <span>量程：</span>
                    <span>{{ selectItem.range }}</span>
                  </div>
                  <div class="rigth_item">
                    <span>保养有效期：</span>
                    <span>{{ selectItem.maintenanceEffectiveTime }}</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="accessory">
          <div class="accessory-title">附件:</div>
          <div class="accessory-content bar">
            <template v-for="(item, index) in particular.files">
              <div
                class="accessory-item"
                :key="index"
                @click="toDownload(item)"
              >
                <span class="left">
                  <i class="iconfont icon-word" style="margin-right: 4px"></i>
                  <span class="fileName">{{ item.fileName }}</span>
                  <span class="typeName"> {{ item.typeName }}</span>
                </span>
                <i class="iconfont icon-xiazai-" style="margin-right: 4px"></i>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="popout model">
      <el-dialog
        class="popout model"
        title="修改数据"
        :visible.sync="bdPopout"
        width="564px"
        append-to-body
      >
        <binItemModel v-if="bdPopout" @notarize="notarize"></binItemModel>
        <!-- <selmode></selmode> -->
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import {
  BindingInfo,
  UntieCombind,
  FileUrl,
  changeStates,
} from "@/api/depotApi";
import binItemModel from "./binItem";
export default {
  props: {
    message: Object,
  },
  data() {
    return {
      bdPopout: false,
      DepotId: "",
      selectItem: "",
      selectID: "", //选中仪器的id来判断
    };
  },
  components: {
    binItemModel,
  },
  computed: {
    ...mapState(["depot"]),
    particular() {
      return this.$store.state.depot.redactInstrument;
    },
    showBg() {
      if (this.particular && this.particular.files) {
        let length = this.particular.files.length - 1;
        return length;
      } else {
        return "无";
      }
    },
  },
  mounted() {
    console.log("传来数据", this.particular);
  },
  methods: {
    delelItem() {
      this.$emit("deleteItem", this.particular.id);
    },
    SelecIten(data) {
      //选中仪器展示
      console.log("选中", data);
      this.selectItem = data;
      this.selectID = data.id;
    },
    addYq() {
      this.bdPopout = true;
    },
    notarize(bol, data) {
      if (bol == "true") {
        let dict = [];
        for (let i in data) {
          dict.push(data[i].id);
        }
        let parameter = {
          pid: this.particular.id,
          insId: dict,
        };
        BindingInfo(parameter).then((res) => {
          if (res.code == 200) {
            this.particular.child = this.particular.child.concat(data);
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.$store.dispatch("setUpdateInstr", "true");
          } else {
            this.$message.error(res.msg);
          }
        });

        this.bdPopout = false;
      } else {
        this.bdPopout = false;
      }
    },
    handleClose(tab) {
      //移除设备
      let dict = [];
      if (tab.id == this.selectID) {
        this.selectItem = "";
      }
      dict.push(tab.id);
      let arr = this.particular.child;
      const params = {
        pid: tab.parentId,
        insId: dict,
      }
      UntieCombind(params).then((res) => {
        if (res.code == 200) {
          arr.splice(
            arr.findIndex((item) => item.id === tab.id),
            1
          );
          this.$message.success(res.msg || res.data);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    toDownload(data) {
      FileUrl({ objectName: data.fileName }).then((res) => {
        if (res.code == 200) {
          window.open(res.data)
        }
      });
    },
    //停用
    outage() {
      let data = {
        id: this.particular.id,
        states: 2,
      };
      this.$confirm("此操作将停用该仪器, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        changeStates(data).then((res) => {
          console.log("停用", res);
          if (res.code == "200") {
            this.$message({
              message: "设备停用成功",
              type: "success",
            });
            this.particular.states = 2;
            this.$store.dispatch("setUpdateInstr", "true");
          } else {
            this.$message.error(res.msg);
          }
        });
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除",
        });
      });

    },
  },
  watch: {
    particular(newVal, oldVal) {
      console.log("vuex里数据变化了", newVal, oldVal);
    },
  },
};
</script>

<style lang="less" scoped>
.equipModel {
  width: 100%;
  color: #74c8fe;
  display: flex;
  .left-container {
    width: 31%;
    margin-right: 2%;
    position: relative;
    .head-portrait {
      .imgs-container {
        height: 200px;
        width: 200px;
        margin: auto;
        margin-top: 30px;
        box-shadow: 0 0 15px #0abde6 inset;
        border-radius: 50%;
        -o-object-fit: cover;
        object-fit: cover;
        position: relative;
        img {
          position: absolute;
          width: 120px;
          height: 120px;
          left: 50%;
          top: 50%;
          -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
        }
      }
    }
    .text-conten {
      text-align: center;
      div {
        margin: 10px 0;
      }
      .yq_name {
        font-size: 20px;
      }
      .slogan {
        font-size: 18px;
      }
      .state {
        font-size: 16px;
      }
    }
    .qcode {
      position: absolute;
      left: 50%;
      top: 64%;
      -webkit-transform: translate(-50%, -50%);
      // background: #ffffff;
      .imgs-container {
        width: 350px;
        height: 350px;
        margin: auto;
        // margin-top: 30px;
        // margin-bottom: 10px;
        // box-shadow: 0 0 15px #0abde6 inset;
        background: url("~@/assets/images/qcode.png");
        background-repeat: no-repeat;
        background-position-x: center;
        background-position-y: center;
        background-size: 150%;
        position: relative;
        img {
          position: absolute;
          width: 150px;
          height: 150px;
          left: 52%;
          top: 62%;
          -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
        }
      }
    }
  }
  .right-container {
    width: 69%;
    height: 674px;
    position: relative;
    .btn-list {
      position: absolute;
      right: 0px;
      top: 0;
    }
    .container-title {
      width: 100%;
      margin-top: 25px;
      .instryment-name {
        font-size: 24px;
        margin-right: 20px;
      }
    }
    .Instrument-list {
      //   display: inline-block;
      width: 461px;
      margin-top: 15px;
      height: 560px;
      background: #0a2e60;
      border-radius: 10px;
      box-shadow: 0 0 20px #0071f1 inset;
      //   border: 1px solid #74c8fe;
      box-sizing: border-box;
      float: left;
      position: relative;
      overflow: hidden;
      .vessel {
        width: 100%;
        height: 478px;
        overflow: auto;
        padding: 10px;
        box-sizing: border-box;
      }
      .selec-item {
        box-shadow: 0 0 16px #0283de inset;
      }
      .list-item {
        width: 419px;
        height: 50px;
        border: 2px solid #0482d9;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: auto;
        margin-bottom: 12px;

        .tag-item {
          width: 380px;
          height: 50px;
          line-height: 50px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .tag-icon {
          cursor: pointer;
        }
      }
      .add-buttom {
        width: 419px;
        height: 50px;
        line-height: 50px;
        border: 2px solid #0482d9;
        border-radius: 10px;
        text-align: center;
        margin: auto;
        position: absolute;
        bottom: 10px;
        left: 50%;
        transform: translate(-50%);
        cursor: pointer;
      }
    }
    .Instrument-detail {
      //   display: inline-block;
      float: left;
      margin-left: 30px;
      width: 452px;
      margin-top: 15px;
      height: 560px;
      background: rgb(10, 46, 96);
      border-radius: 10px;
      //   border: 1px solid #74c8fe;
      .detail {
        width: 452px;
        height: 289px;
        background: rgb(10, 46, 96);
        box-shadow: 0 0 20px #0071f1 inset;
        border-radius: 10px;
        position: relative;
        .card-item {
          width: 100%;
          //   box-shadow: 0 0 33px#0090F0 inset;
          border-radius: 4px;
          height: 289px;
          border-radius: 10px;

          .card-item-top {
            width: 100%;
            height: 120px;
            // border-bottom: 1px solid #0071f1;
            display: flex;
            .equip-imag {
              width: 120px;
              text-align: center;
              display: inline-block;
              .imgs-icon {
                margin-top: 16px;
                //   width: 80px;
                //   height: 80px;
              }
            }
            .equip-detail {
              display: inline-block;
              width: 332px;
              height: 100%;
              .items {
                height: 40px;
                line-height: 40px;
                color: #74c8fe;
                /*line-height: 75%;*/
                font-size: 16px;
                margin-top: 20px;
                margin-left: 10px;
              }
              .tow-columns {
                display: flex;
                justify-content: space-between;
                color: #74c8fe;
                /*line-height: 75%;*/
                // font-size: 16px;
                margin-top: 10px;
                margin-left: 10px;
                .left_item {
                  width: 50%;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                .rigth_item {
                  width: 50%;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
            }
          }
          .card-item-bottom {
            width: 100%;
            height: 160px;
            padding: 8px 15px;
            box-sizing: border-box;
            // box-shadow: 0 0 15px #0071f1 inset;
            .row-item {
              color: #74c8fe;
              font-size: 16px;
              height: 38px;
              line-height: 38px;
              .left_item {
                display: inline-block;
                width: 33%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .rigth_item {
                display: inline-block;
                width: 65%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
        }
      }
      .detail::after {
        content: "";
        position: absolute;
        top: 20%;
        right: 100%;
        margin-top: -5px;
        border-width: 10px;
        border-style: solid;
        border-color: transparent #02478e transparent transparent;
      }
      .accessory {
        width: 452px;
        height: 260px;
        background: rgb(10, 46, 96);
        margin-top: 10px;
        .accessory-title {
          height: 30px;
          line-height: 30px;
          font-size: 18px;
        }
        .accessory-content {
          width: 452px;
          height: 230px;
          box-shadow: 0 0 20px #0071f1 inset;
          border-radius: 10px;
          overflow: auto;
          padding: 10px;
          box-sizing: border-box;
          .accessory-item {
            width: 100%;
            height: 38px;
            margin-bottom: 12px;
            border: 2px solid #018be9;
            padding: 0 10px;
            box-sizing: border-box;
            border-radius: 4px;
            cursor: pointer;
            background: linear-gradient(
              180deg,
              rgba(49, 210, 255, 0.52),
              rgba(0, 57, 142, 0.52)
            );
            display: flex;
            justify-content: space-between;
            align-items: center;
            .left {
              display: inline-block;
              width: 98%;
              white-space: nowrap;
              display: flex;
              align-items: center;
              .fileName {
                width: 72%;
                min-width: 180px;
                overflow: hidden; //超出的文本隐藏
                text-overflow: ellipsis; //溢出用省略号显示
                white-space: nowrap;
                display: inline-block;
              }
              .typeName {
                display: inline-block;
                width: 28%;
                min-width: 100px;
                overflow: hidden; //超出的文本隐藏
                text-overflow: ellipsis; //溢出用省略号显示
                white-space: nowrap;
              }
            }
            color: #74c8fe;
          }
        }
      }
    }
  }
  .left-div,
  .middle-div,
  .right-div {
    .btn-list {
      text-align: right;
      margin: 13px 20px;
      width: 100%;
    }
  }
  .left-div {
    margin-right: 2%;
    .head-portrait {
      .imgs-container {
        height: 200px;
        width: 200px;
        margin: auto;
        margin-top: 30px;
        box-shadow: 0 0 15px #0abde6 inset;
        border-radius: 50%;
        -o-object-fit: cover;
        object-fit: cover;
        position: relative;
        img {
          position: absolute;
          width: 120px;
          height: 120px;
          left: 50%;
          top: 50%;
          -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
        }
      }
    }
    .text-conten {
      text-align: center;
      div {
        margin: 10px 0;
      }
      .yq_name {
        font-size: 20px;
      }
      .slogan {
        font-size: 18px;
      }
      .state {
        font-size: 16px;
      }
    }
  }
  .addyq {
    width: 5200px;
    height: 462px;
    color: yellow;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Instrumentmanagemen/components/yqz/equipModel1.vue